import * as React from 'react';
import { pathOr } from 'ramda';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { TYPE_FIELDS_MAP, TTextFieldType } from './constants';
import { useOfferContext } from '../../../../../../utils/offerContext';

interface ITextFieldContainerProps {
  type: TTextFieldType;
}

export const TextFieldContainer: React.VFC<ITextFieldContainerProps> = ({ type }) => {
  const offerContext = useOfferContext();
  const path = TYPE_FIELDS_MAP[type];
  const displayText = pathOr(null, path, offerContext);

  if (!displayText) {
    return <EmptyField published={offerContext.published} />;
  }

  return <TextField published={offerContext.published}>{displayText}</TextField>;
};
